import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['container', 'percentage', 'zoomInButton', 'zoomOutButton'];
  static values = { zoomLevel: { type: String } };
  static outlets = ['overview--drag-and-drop'];

  connect() {
    this.percentageTarget.textContent = `${Math.round(parseFloat(this.zoomLevelValue) * 100)}%`;
    this._setButtonStates();
  }

  zoomIn() {
    if (parseFloat(this.zoomLevelValue) < 1) {
      const newZoomLevel = parseFloat(this.zoomLevelValue) + 0.25;
      this._changeZoom(newZoomLevel);
    }
  }

  zoomOut() {
    if (parseFloat(this.zoomLevelValue) > 0.25) {
      const newZoomLevel = parseFloat(this.zoomLevelValue) - 0.25;
      this._changeZoom(newZoomLevel);
    }
  }

  _setButtonStates() {
    this.zoomInButtonTarget.disabled = parseFloat(this.zoomLevelValue) >= 1;
    this.zoomOutButtonTarget.disabled = parseFloat(this.zoomLevelValue) <= 0.25;
  }

  _changeZoom(newZoomLevel) {
    this.zoomLevelValue = newZoomLevel;
    this.containerTarget.classList.remove('zoom-0.25', 'zoom-0.5', 'zoom-0.75', 'zoom-1');
    this.containerTarget.classList.add(`zoom-${newZoomLevel}`);
    this.percentageTarget.textContent = `${Math.round(newZoomLevel * 100)}%`;
    this._setButtonStates();
    this._storeState();
    this.overviewDragAndDropOutlet.changeZoomLevel(newZoomLevel);
  }

  _storeState() {
    let formData = new FormData();
    formData.append('zoom', this.zoomLevelValue);

    Rails.ajax({
      url: '/admin/overview_zoom',
      type: 'PATCH',
      data: formData
    });
  }
}
